import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: "",
  role: "",
  email: "",
  lastName: "",
  firstName: "",
  planStatus: "",
  profileImage: "",
  isVerified: false,
  selectPlan: false,
  yourDetails: false,
  paymentSetup: false,
  isAccountOwner: null,
  isRiskFreeTier: false,
  isFromSettings: false,
  displayCongrats: false,
  canExtendTrial: false,
  termsAndConditions: false,
  isCardDetailsFilled: false,
  planRemainingGraceDays: null,
  isStoppedNativusCoachSubscription: false,
  tourProgress: null,
};

export const userSlice = createSlice({
  name: "userDetails",
  initialState,
  reducers: {
    setUserFirstAndLastName: (state, action) => {
      const { firstName, lastName } = action.payload;
      state.firstName = firstName;
      state.lastName = lastName;
    },
    setUserDetails: (state, action) => {
      const {
        id,
        plan,
        role,
        email,
        last_name,
        first_name,
        select_plan,
        is_verified,
        your_details,
        payment_setup,
        profile_image,
        isAccountOwner,
        terms_and_conditions,
      } = action.payload;

      state.id = id;
      state.role = role;
      state.email = email;
      state.lastName = last_name;
      state.firstName = first_name;
      state.isVerified = is_verified;
      state.selectPlan = select_plan;
      state.planStatus = plan.status;
      state.yourDetails = your_details;
      state.paymentSetup = payment_setup;
      state.profileImage = profile_image;
      state.isAccountOwner = isAccountOwner;
      state.isRiskFreeTier = plan.isRiskFreeTier;
      state.canExtendTrial = plan.canExtendTrial || false;
      state.termsAndConditions = terms_and_conditions;
      state.isCardDetailsFilled = plan.isCardDetailsFilled;
      state.planRemainingGraceDays = plan.remaining_grace_days;
      state.isStoppedNativusCoachSubscription = plan.isStoppedNativusCoachSubscription;
    },
    setYourDetailsCompleted: (state) => {
      state.yourDetails = true;
    },
    setSelectPlanCompleted: (state) => {
      state.selectPlan = true;
    },
    setTermsAndConditionsCompleted: (state) => {
      state.termsAndConditions = true;
    },
    setPaymentSetUpCompleted: (state) => {
      state.paymentSetup = true;
    },
    setDisplayCongrats: (state, action) => {
      state.displayCongrats = action.payload;
    },
    setPlanDetails: (state, action) => {
      state.planStatus = action.payload.status;
      state.planRemainingGraceDays = action.payload.planRemainingGraceDays;
    },
    setIsRiskFreeTier: (state, action) => {
      state.isRiskFreeTier = action.payload;
    },
    setIsCardDetailsFilled: (state, action) => {
      state.isCardDetailsFilled = action.payload;
    },
    setIsStoppedNativusCoachSubscription: (state, action) => {
      state.isStoppedNativusCoachSubscription = action.payload;
    },
    setCanExtendTrial: (state, action) => {
      state.canExtendTrial = action.payload;
    },
    setIsFromSettings: (state, action) => {
      state.isFromSettings = action.payload;
    },
    setTourProgress: (state, action) => {
      state.tourProgress = action.payload;
    },
    updateTourStep: (state, action) => {
      if (state.tourProgress) {
        state.tourProgress.last_step_viewed = action.payload;
      }
    },
    completeTour: (state) => {
      if (state.tourProgress) {
        state.tourProgress.tour_completed = true;
        state.tourProgress.completed_at = new Date().toISOString();
      }
    },
    updateChecklistItem: (state, action) => {
      const { itemKey, completed } = action.payload;
      if (state.tourProgress && state.tourProgress.checklist_items) {
        state.tourProgress.checklist_items[itemKey] = completed;
      }
    },
    updateChecklistItems: (state, action) => {
      if (state.tourProgress) {
        state.tourProgress.checklist_items = {
          ...state.tourProgress.checklist_items,
          ...action.payload,
        };
      }
    },
    resetUserDetails: () => initialState,
  },
});

export const {
  setUserFirstAndLastName,
  setUserDetails,
  setYourDetailsCompleted,
  setSelectPlanCompleted,
  setTermsAndConditionsCompleted,
  setPaymentSetUpCompleted,
  resetUserDetails,
  setDisplayCongrats,
  setPlanDetails,
  setIsRiskFreeTier,
  setIsCardDetailsFilled,
  setIsFromSettings,
  setIsStoppedNativusCoachSubscription,
  setCanExtendTrial,
  setTourProgress,
  updateTourStep,
  completeTour,
  updateChecklistItem,
  updateChecklistItems,
} = userSlice.actions;

export default userSlice.reducer;
